export * from './minha-conta.component';